import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";

import { INotificationRecipientType } from "../api/notifications.api";

export const getNotificationAudienceText = (notificationType: INotificationRecipientType, terminology: ITerminology): string => {
  if (notificationType === "global") {
    return `All platform ${terminology.user.plural.text}`;
  } else if (notificationType === "customer") {
    return `Multiple ${terminology.customer.singular.text} ${terminology.user.plural.text}`;
  } else {
    return `Multiple ${terminology.drop.singular.text} ${terminology.user.plural.text}`;
  }
};
